import { Dispatch, SetStateAction } from 'react'

export type Group = {
  agency_name: string
  broker_name: string
  group_id: string
  group_name: string
  office_location: string
  user_id: number
}

export type Agency = {
  name: string
}

export type UserInfo = {
  username: string
  email: string
  temporary: boolean
  user_type: string
  authuser_id: number
  first_name: string
  last_name: string
  groups: Group[]
  agency: Agency
  phone_number: string | null
}

export enum AppType {
  Public = 'public',
  Authenticated = 'authenticated',
  Loading = 'loading'
}

export interface IAuthContext {
  login: (username: string, password: string) => Promise<any>
  loginWithToken: Function
  logout: Function
  refreshUserData: Function
  userData: UserInfo | null
  appType: AppType
  authLoading: boolean
  setAppType: Dispatch<SetStateAction<AppType>>
}
